import AdvancedSearch from '@app/components/AdvancedSearch'
import CheckBox from '@app/components/CheckBox'
import FeedItemEditor from '@app/components/FeedItemEditor'
import ItemLeadsList from '@app/components/ItemLeadsList'
import SearchBar from '@app/components/SearchBar'
import { FeedItemSourceType, FeedItemType } from '@app/models/enums'
import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Col, FormGroup, Label } from 'reactstrap'
import { PropertyPageProps } from './PropertyPage'

interface IPropertyLeadsState {
  filterText: string
}

export default class PropertyLeads extends React.PureComponent<
  PropertyPageProps,
  IPropertyLeadsState
> {
  constructor(props: any) {
    super(props)

    this.state = {
      filterText: '',
    }

    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title={`${this.props.property.name} :: Leads`}>
        <div className='mb-3'>
          <FeedItemEditor
            contextId={this.props.match.params.id}
            contextType={FeedItemSourceType.Property}
            itemType={FeedItemType.Lead}
          />
          <SearchBar
            className='mt-3'
            value={this.state.filterText}
            onChange={this._setFilterText}
            placeholder='Filter leads...'
            size='sm'
          />
          <AdvancedSearch className='mt-1' expand='md'>
            <Col
              md={4}
              xl={3}
              style={{ alignSelf: 'flex-end', marginBottom: '4px' }}
            >
              <FormGroup>
                <Label />
                <CheckBox
                  value={this.props.includeArchivedLeads}
                  onChange={this._onChangeIncludeArchived}
                />{' '}
                Include archived
              </FormGroup>
            </Col>
          </AdvancedSearch>
          {this._renderLeads()}
        </div>
      </DocumentTitle>
    )
  }

  private _onChangeIncludeArchived(value: boolean) {
    this.props.setIncludeArchived(value)
  }

  private _renderLeads() {
    const leads = !this.state.filterText
      ? this.props.property.leads
      : this.props.property.leads
          .filter((l) => {
            return (
              l !== undefined &&
              ((l.title !== undefined &&
                l.title
                  .toLowerCase()
                  .indexOf(this.state.filterText.toLowerCase()) > -1) ||
                l.markup
                  .toLowerCase()
                  .indexOf(this.state.filterText.toLowerCase()) > -1)
            )
          })
          .toList()

    return (
      <ItemLeadsList
        className='mt-3'
        leads={leads}
        displayArchivedLeads={this.props.includeArchivedLeads}
        onArchive={(id) => this.props.archiveLead(id)}
        onClick={(id) => this.props.history.push(`/feed/${id}`)}
      />
    )
  }

  private _setFilterText(newFilterText: string) {
    this.setState({ filterText: newFilterText })
  }
}
